import React from 'react';

import Message from '@utils/message/Message';
import { MessageType } from '@utils/message/types';

export const ComingSoonPage = () => (
    <div className="sgw-layout seven-four-container">
        <div className="sgw-layout-item seven">
            <div className="sgw-layout-item">
                <Message type={MessageType.COMING_SOON} />
            </div>
        </div>
    </div>
);
